import { i18n, IIndexSignature } from '@selfserve/react-utils';

export const productStatusesTexts: IIndexSignature<string> = {
  0: i18n.t('common.enabled'),
  1: i18n.t('common.disabled'),
  2: i18n.t('common.deleted'),
};

export const partnerStatusesTexts: IIndexSignature<string> = {
  0: i18n.t('common.deleted'),
  1: i18n.t('common.active'),
  2: i18n.t('common.blocked'),
  3: i18n.t('common.full-block'),
  4: i18n.t('common.read-only'),
};

export const subscriptionStatusesTexts: IIndexSignature<string> = {
  inTrial: i18n.t('common.in-trial'),
  active: i18n.t('common.active'),
  deleted: i18n.t('common.deleted'),
  pending: i18n.t('common.pending'),
  cancelled: i18n.t('common.cancelled'),
  paused: i18n.t('common.paused'),
};

export const checklistStatusesTexts: IIndexSignature<string> = {
  enable: i18n.t('common.enable'),
  disable: i18n.t('common.disable'),
};
